var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5719 17.8282C19.7106 16.5176 20.3999 14.806 20.3999 12.9335C20.3999 8.80983 17.0569 5.4668 12.9332 5.4668C8.8095 5.4668 5.46655 8.80983 5.46655 12.9335C5.46655 17.0573 8.80941 20.4001 12.9332 20.4001C14.8054 20.4001 16.5166 19.7111 17.8271 18.5729C17.8452 18.5973 17.8659 18.6212 17.8894 18.6447L22.156 22.9114C22.6589 23.4142 23.4131 22.6599 22.9103 22.1571L18.6436 17.8904C18.6202 17.867 18.5963 17.8463 18.5719 17.8282ZM19.3334 12.9326C19.3334 9.39801 16.468 6.53255 12.9334 6.53255C9.39876 6.53255 6.53337 9.39801 6.53337 12.9326C6.53337 16.4673 9.39866 19.3326 12.9334 19.3326C16.4681 19.3326 19.3334 16.4673 19.3334 12.9326Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.907baf0feb3ff7c5944d375ba020f972.svg";
export { ForwardRef as ReactComponent };